export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Italic.ttf?b257a18c016f37ee45430f59757a0db9";